import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { overlandParkConfig } from "./data";

export default function OverlandParkPage() {
  return <CityPageTemplate config={overlandParkConfig} />;
}